/**
 * Utility functions for generating UUIDs
 */

// Simple UUID v4 generator for frontend use
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Generate a short UUID (8 characters)
export const generateShortUUID = () => {
  return Math.random().toString(36).substring(2, 10);
};

// Generate a section ID with prefix
export const generateSectionId = (prefix = 'section') => {
  return `${prefix}-${generateUUID()}`;
};

// Validate if a string is a valid UUID
export const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}; 